import _ from 'underscore';
import axios from 'axios';
import { TableauViz } from '@tableau/embedding-api';

import config from '~/config';
import EventBus from '~/adready-vue/helpers/global/event-bus';
import advertiserApi from '~/api/advertiser';

const props = {};
const computed = {};
const methods = {
  async initTableau(useAiData = true, retries = 0) {
    // This function uses isLoading so make sure that the component has that data property
    // defined and initialized to false.
    const maxRetries = 20;
    if (retries > maxRetries) {
      console.error('Max retries reached for initTableau');
      return;
    }
    try {
      this.loading = true;
      await this.getTableauAuthToken();
      if (useAiData) {
        await this.fetchTableauRestApiAuthToken();
        this.selectedTabTitle = this.selectedTabTitle ? this.selectedTabTitle : 'Overview';
        if (this.hasAIAssistantAccess) {
          await this.fetchAllTableauData();
          this.isComponentMounted = true;
        }
      }
      this.loading = false;
    } catch (error) {
      console.error('Error in initTableau: ', error);
      this.loading = false;
    }
  },
  debounceTableauAuthToken() {
    _.debounce(this.getTableauAuthToken(), 100, true);
  },
  async getTableauAuthToken(maxRetries = 3) {
    this.loading = true;
    if (maxRetries < 1) return;
    try {
      const d = await axios.get(`${config.ADREADY_URL}/api/token/tableau`, {
        withCredentials: true,
      });
      this.tableauJwtToken = d.data.result;
      if (d.status !== 200) {
        await this.getTableauAuthToken(maxRetries - 1);
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      console.error('Error fetching Tableau auth token: ', error);
    }
  },
  async initializeTableau(tableauComponent) {
    // This function uses isTableauDashboardInitialized so make sure that the component has that data property
    // defined and initialized to false.
    const viz = new TableauViz();

    viz.src = this.tableauViewURL;
    viz.token = this.tableauJwtToken;
    viz.toolbar = 'hidden';

    if (tableauComponent) {
      tableauComponent.appendChild(viz);
    }

    this.viz = viz;
    this.isTableauDashboardInitialized = true;
  },
  handleTableauError(e) {
    console.error('Error fetching Tableau: ', e);
    if (e.detail.errorCode === 'auth-failed') {
      this.debounceTableauAuthToken();
    }
  },
  async fetchDsp(retries = 0) {
    const maxRetries = 20;
    if (retries > maxRetries) {
      console.error('Max retries reached for fetchDsp');
      return;
    }
    if (EventBus.universalPixelIdReady && this.universalPixelId) {
      try {
        const response = await advertiserApi.getDspIdByUniversalPixelId(this.universalPixelId);

        if (response && response.length) {
          this.dspAdvertiserIds = response.filter((res) => res).join('\\,');
        } else {
          this.dspAdvertiserIds = '';
        }
      } catch (error) {
        console.error('Error fetching DSP Advertiser IDs: ', error);
        this.dspAdvertiserIds = '';
      }
      return;
    }
    await new Promise((resolve) => setTimeout(resolve, 100));
    await this.fetchDsp(retries + 1);
  },
  async fetchTableauRestApiAuthToken() {
    try {
      const d = await axios.get(
        `${config.ADREADY_URL}/api/token/tableau/sign/${this.advertiser.id}`,
        {
          withCredentials: true,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': true,
        }
      );
      if (d.data.result) {
        this.tableauRestToken = d.data.result;
      }
      return d;
    } catch (error) {
      console.error('Error fetching Tableau REST API auth token: ', error);
      return null;
    }
  },
};

export default {
  props,
  computed,
  methods,
};
